var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('baidu-map',{staticClass:"map-box",attrs:{"center":_vm.center,"zoom":16},on:{"ready":_vm.handler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }